module.exports = "/_next/static/images/img__1-26b102bec0db7c39aa81194ffd26e89a.png";